import DocumentsProvider from './Documents.provider';

export default DocumentsProvider;
